import { FC } from 'react';

export const Careers: FC = () => (
  <div className="max-w-4xl mx-auto px-6 py-12">
    <h1 className="text-4xl font-bold text-theme-primary mb-4">Careers</h1>
    <p className="text-lg text-theme-muted mb-8">
      We’re not hiring right now, but we’re always interested in hearing from people who care about developer tools and open source.
    </p>
    <div className="p-6 rounded-xl border border-theme-border bg-theme-secondary inline-flex items-center gap-2">
      <span className="text-forge-400 font-medium">Coming soon.</span>
    </div>
  </div>
);
